exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".attLocIntro strong{font-weight:600}.warn{color:#d29400}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/schema/edit-schema/location/schema.edit.scss
// module id = 1187
// module chunks = 0 2